import { render } from "./BomHeader.vue?vue&type=template&id=624ac7ed"
import script from "./BomHeader.vue?vue&type=script&lang=js"
export * from "./BomHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__